
import state from './moduleCoachState.js'
import mutations from './moduleCoachMutations.js'
import actions from './moduleCoachActions.js'
import getters from './moduleCoachGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}